import { createSingletonMixin } from '@descope/sdk-helpers';

const cookieConfigMixin = createSingletonMixin((superclass) => {
    return class CookieConfigMixinClass extends superclass {
        get refreshCookieName() {
            return this.getAttribute('refresh-cookie-name') || '';
        }
    };
});

export { cookieConfigMixin };
//# sourceMappingURL=cookieConfigMixin.js.map
